import { isSpSize } from "../common/utils/isSpSize";

class Message {
  // ---------------------------------------------------------------------------
  // --	Message
  // ---------------------------------------------------------------------------

  constructor(elm) {
    //DOM参照
    this.$elm = elm;
    this.$page = document.querySelector("#page_home");

    //再生済みかどうかのフラグ
    this.isPlayed = false;

    //スクロールハンドリング
    window.addEventListener("scroll", this.update.bind(this));

    //リサイズハンドリング
    window.addEventListener("resize", this.update.bind(this));

    //Timeline生成
    this.tl = gsap.timeline().pause();
    const lines = this.$elm.querySelectorAll(
      isSpSize() ? ".-line-md" : ".-line"
    );
    lines.forEach((line) => {
      gsap.set(line, {
        alpha: 0,
        y: isSpSize() ? 50 : 100,
      });
      this.tl.to(
        line,
        {
          alpha: 1,
          y: 0,
          ease: "power1.out",
          duration: 1,
        },
        "<+=0.1"
      );
    });
    this.lineH = lines[0].offsetHeight;
    if (!isSpSize()) this.lineH *= 1.5;
    this.lineNum = lines.length;

    //初回のアップデート
    this.update();
  }

  /**
   * アップデート
   */
  update() {
    if (this.isPlayed) return;

    //ヘッダーとウィンドウの高さ
    const headerH = isSpSize()
      ? 0
      : document.querySelector("#global_header").clientHeight;
    const windowH = window.innerHeight;

    //コンテナとプロジェクトエリアの範囲
    const targetY = -this.$elm.getBoundingClientRect().y;

    //再生
    if (targetY >= -windowH * 0.8 && !this.isPlayed) {
      this.isPlayed = true;
      this.tl.play();
    }
  }

  // ---------------------------------------------------------------------------
}

export default Message;
